import React from "react";
import styled from "styled-components";
import ThinkBubble from "./ThinkBubble";
import { Divider, MainTitle } from "../styled";

const Container = styled.div`
  background-color: #000;
  padding: 40px 0;
  display: flex;
  flex-direction: column;

  #feedback-carousel {
    width: 100%;
    text-align: center;
    --swiper-navigation-size: 30px;
    --swiper-navigation-top-offset: 50%;
    --swiper-navigation-sides-offset: 0;
    --swiper-navigation-color: #008080;
  }

  h2 {
    text-align: center;
    color: #fff;
    font-weight: bold;
  }
`;

const feedbacks = [
  {
    feedback:
      "Hajvágás után kiléptem az utcára és kettő percen belül 6 lány kérte el a telefonszámom.",
    name: "Attila O.",
  },
  {
    feedback:
      "Minden csillagos 5-ös, a legjobb hely Győrben, a legjobb barberekkel.",
    name: "János G.",
  },
  {
    feedback:
      "Csodálatos környezet és csodálatos élmény volt ehhez társult egy remek haj",
    name: "Kevin H.",
  },
  {
    feedback:
      "Szuper lett kisfiam frizurája, nagyon tetszett neki. Legközelebb is Hozzátok jövünk. :-) ",
    name: "Márta Emma B.",
  },
  {
    feedback:
      "Exkluzív környezetben elsőosztàlyù kiszolgàlàs. Külön kényelmi szolgàltatàs az online időpontfoglalàs-annak visszaigazolàsa+ az emlèkeztető a telefonon. Nagyon smart👌",
    name: "Helga B.",
  },
  {
    feedback:
      "tokeletes volt, nagyon szepen megcsinaltak a hajam es mindenki jofej volt!",
    name: "Dominik",
  },
];

const Feedbacks = () => {
  return (
    <Container>
      <MainTitle>Vendégeink mondták</MainTitle>
      <Divider />
      <swiper-container
        id="feedback-carousel"
        navigation="true"
        slides-per-view="1"
        height="100"
      >
        {feedbacks.map((feedback, index) => {
          return (
            <swiper-slide key={index}>
              <ThinkBubble
                key={index}
                text={feedback.feedback}
                name={feedback.name}
              />
            </swiper-slide>
          );
        })}
      </swiper-container>
      <Divider />
    </Container>
  );
};

export default Feedbacks;
